import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../../Components/Loader/Loader";
import testImg from "../../../../Assets/img/test-img.png";
import {
  errorMessage,
  getScoringSchemes,
} from "../../../../Features/LKWBTestApi/LKWBTestApi";

const LKWBTest = () => {
  const token = useSelector((state) => state.auth.currentUser.token);
  const [schemes, setSchemes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    getScoringSchemes(token)
      .then((data) => {
        if (cancelled) return;
        setSchemes(Array.isArray(data) ? data : []);
        setError("");
      })
      .catch((err) => {
        if (!cancelled) setError(errorMessage(err, "Unable to load LKWB tests."));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (isLoading) {
    return (
      <div className="loading__mode bigloading">
        <Loader />
      </div>
    );
  }

  return (
    <div className="ubt-container">
      <h2 className="dashboard-page-title">LKWB Test</h2>

      {error ? (
        <div className="youhavenot-container">
          <p>{error}</p>
        </div>
      ) : schemes.length === 0 ? (
        <div className="youhavenot-container">
          <p>No tests available at the moment.</p>
        </div>
      ) : (
        <div className="ubtSetQuestions setstitem-container">
          {schemes.map((item) => {
            const detailLink = `/dashboard/lkwb-test/${item.id}`;
            return (
              <div key={item.id} className="item-notbought setsitem-container lkwb-card">
                <div className="setsitem-header">
                  <div className="pdficon">
                    <img src={testImg} alt="" />
                    <div className="sets-content">
                      <div>
                        <h3>
                          <Link to={detailLink}>{item.title}</Link>
                        </h3>
                        <p className="lkwb-meta">
                          {[
                            item.mode_label,
                            `${item.total_questions} Questions`,
                            `${item.total_marks} Marks`,
                          ]
                            .filter(Boolean)
                            .join(" · ")}
                        </p>
                      </div>
                      <div className="text-end">
                        {item.published_sets_count > 0 ? (
                          <Link to={detailLink} className="btn btn-small">
                            View Sets
                          </Link>
                        ) : (
                          <span className="lkwb-soon">Coming Soon</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LKWBTest;
